import { z } from 'zod';
import { activityEntrySchema } from './activity';
import { boardSchema } from './board';
import { publicProfileSchema } from './user';

/**
 * Route-specific contract for `GET /users/:id/profile-page` (B44, BE-44.2).
 *
 * This is deliberately an aggregate shape rather than a widening of
 * `publicProfileSchema`, `boardSchema` or `activityEntrySchema`. Each of those
 * schemas serialises existing routes whose payloads must not grow just because
 * the profile page needs a composed view.
 */

export const PROFILE_PAGE_BOARDS_LIMIT = 12;
export const PROFILE_PAGE_RECENT_ACTIVITY_LIMIT = 20;

export const profilePageBoardSchema = boardSchema;

export type ProfilePageBoard = z.infer<typeof profilePageBoardSchema>;

export const profilePageActivityEntrySchema = activityEntrySchema;

export type ProfilePageActivityEntry = z.infer<typeof profilePageActivityEntrySchema>;

export const profilePageSchema = z.object({
  profile: publicProfileSchema,
  boards: z.array(profilePageBoardSchema).max(PROFILE_PAGE_BOARDS_LIMIT),
  recentActivity: z
    .array(profilePageActivityEntrySchema)
    .max(PROFILE_PAGE_RECENT_ACTIVITY_LIMIT),
});

export type ProfilePage = z.infer<typeof profilePageSchema>;
